import React from 'react';
import './Signup.css';
import Logo from '../assets/Images/Logo.png';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Link } from 'react-router-dom';
import { apiService } from '../services/apiService'; // adjust path if needed
import { useNavigate } from 'react-router-dom';

const Signup = () => {
  const [firstName, setFirstName] = React.useState('');
  const [lastName, setLastName] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');
  const navigate=useNavigate()
  const handleSubmit = async () => {
    try {
      await apiService.signup({
        email,
        name: `${firstName} ${lastName}`,
        password,
        environment: 'test',
      });
      navigate('/');
    } catch (error) {
      console.log(error.message);
    }
  };

  return (
    <div className="signup-container">
      <div className="signup-wrapper">
        <div className="signup-wrapper-container">
          <div className="signup-left">
            <div className="signup-left-header">
              <h2 className="signup-title">Create Account</h2>
              <p className="signup-subtitle">Start your free trial</p>
            </div>

            <div className="signup-form">
              <InputText 
                placeholder="First name" 
                value={firstName} 
                onChange={(e) => setFirstName(e.target.value)} 
              />
              <InputText 
                placeholder="Last name" 
                value={lastName} 
                onChange={(e) => setLastName(e.target.value)} 
              />
              <InputText 
                placeholder="Email" 
                value={email} 
                onChange={(e) => setEmail(e.target.value)} 
              />
              <InputText 
                placeholder="Password" 
                type="password" 
                value={password} 
                onChange={(e) => setPassword(e.target.value)} 
              />
              <Button 
                label="Start your free trial" 
                className="signup-btn" 
                onClick={handleSubmit} 
              />
              <p className="login-redirect">
                Already have an account? <Link to="/">Log in</Link>
              </p>
            </div>
          </div>

          <div className="signup-right">
            <div className="signup-right-content">
              <div className='signup-right-header'>
              <img src={Logo} alt="Contract Review Logo" className="signup-right-logo" />
              </div>
              <h3 className="signup-right-heading">Instant Contract Review</h3>
              <ul className="signup-features">
  <li><i className="pi pi-check check-icon" /><span>Generate a risk summary for your contracts</span></li>
  <li><i className="pi pi-check check-icon" /><span>Flag important clauses automatically</span></li>
  <li><i className="pi pi-check check-icon" /><span>Understand key obligations before signing</span></li>
</ul>



            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Signup;
